import { useContext } from 'react'
import { GlobalContext } from 'App'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';

import Img1 from 'assets/Home/portfolio/show1.avif'
import Img2 from 'assets/Home/portfolio/show2.avif'
import Img3 from 'assets/Home/portfolio/show3.avif'

const Showplus = ({ data }: any) => {
    const { isTablet } = useContext(GlobalContext)

    return (
        <>
            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Main Page
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    쇼플러스는 숏폼 온라인 경영 플랫폼으로{!isTablet && <br />}
                    다양한 경연을 통해 사용자들의 참여를 유도하고,{!isTablet && <br />}
                    새로운 문화와 예술의 가치를 알립니다.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    쇼플러스 이용자들을 쇼플러스가 지원하는 경연에 동영상을{!isTablet && <br />}
                    업로드하는 방식으로 참여가 가능하고 우승시에는 그에 따른{!isTablet && <br />}
                    보상을 받는 양방향 소통 플랫폼입니다.
                </motion.h4>

                <motion.img
                    src={Img1}
                    alt="Img1"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>

            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Competition Guide
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    노래, 연기, 개그, 뮤지컬 등 다양한 분야에서의{!isTablet && <br />}
                    경연을 통해 팔로우를 늘리고 추천을 늘릴수 있습니다.{!isTablet && <br />}
                    숏폼을 올리고 경연에서 우승해 상금을 받아보세요.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    다양한 분야에서 진행되는 경연은 사용자 모두가 참여 할 수 있습니다.{!isTablet && <br />}
                    여러 사용자들과 경쟁에서 승리하신다면 쇼플러스에서 제공하는{!isTablet && <br />}
                    상금을 즉시 받아 보실수 있습니다.
                </motion.h4>

                <motion.img
                    src={Img2}
                    alt="Img2"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>

            <section className='pb-24 tablet:pb-8 container'>
                <motion.img
                    src={Img3}
                    alt="Img3"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>
        </>
    )
}

export default Showplus
